import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {LegacySetupTableContainer} from 'shells/table/legacy-setup-table-container';
import {LegacySetupTableWrapper} from 'shells/table/legacy-setup-table-wrapper';
import {AddButtonRow} from 'shells/table/table-body/add-button-row';

import type {GetAssignments_meeting_assignments_edges as Assignment} from 'nutshell-graphql-types';

import {AssignmentTable} from './assignment-table';
import {AssignmentTableEmptyState} from './assignment-table-empty-state';
import {UsersTeamsSelectionModal} from './users-teams-selection-modal';

type Props = {
    userAssignments: Assignment[];
    isLoading: boolean;
    onAssignmentChange: (assignments: string[]) => void;
    onResetSeveredMeeting: (severedMeetingId: string) => void;
};

export function UsersTable(props: Props) {
    const [isOpen, setIsOpen] = React.useState(false);

    // @ts-expect-error
    const meetings = props.userAssignments.flatMap((user) => user.meetings);
    const selectedUsers = props.userAssignments.map((user) => user.node.assigneeEntity);

    return (
        <>
            <LegacySetupTableWrapper title='Users'>
                <StackLegacy spacing={16}>
                    <LegacySetupTableContainer>
                        <AssignmentTable
                            assignedMeetings={meetings}
                            firstRow={
                                <AddButtonRow
                                    buttonText='Assign a user'
                                    onClick={() => setIsOpen(true)}
                                />
                            }
                            specialStates={[
                                {
                                    shouldRender: () => props.isLoading,
                                    component: <LoadingPage />,
                                },
                                {
                                    shouldRender: () => props.userAssignments.length === 0,
                                    component: (
                                        <AssignmentTableEmptyState
                                            title='No users assigned'
                                            description='Assign a user to this meeting so they can start booking leads'
                                        />
                                    ),
                                },
                            ]}
                            onUnassign={(assigneeId) => {
                                const newSelectedUsers = selectedUsers.filter(
                                    (user) => user.id !== assigneeId
                                );
                                props.onAssignmentChange(newSelectedUsers.map((user) => user.id));
                            }}
                            onResetSeveredMeeting={(severedMeetingId) => {
                                props.onResetSeveredMeeting(severedMeetingId);
                            }}
                        />
                    </LegacySetupTableContainer>
                </StackLegacy>
            </LegacySetupTableWrapper>
            {isOpen && (
                <UsersTeamsSelectionModal
                    isOpen={isOpen}
                    // @ts-expect-error
                    selected={selectedUsers}
                    type='users'
                    onSelection={({selectedUsers: newSelectedUsers}) => {
                        props.onAssignmentChange(newSelectedUsers);
                        setIsOpen(false);
                    }}
                    onClose={() => setIsOpen(false)}
                />
            )}
        </>
    );
}
